/** Load isolated controllers on demand, including editor and quick-add DOM insertions. */
const components = new Map([
  ['product-sku-component', () => import('@theme/product-sku')],
  ['product-inventory', () => import('@theme/product-inventory')],
  ['layered-slideshow-component', () => import('@theme/layered-slideshow')],
  ['video-background-component', () => import('@theme/video-background')],
  ['media-gallery', () => import('@theme/media-gallery')],
  ['volume-pricing', () => import('@theme/volume-pricing')],
  ['volume-pricing-info', () => import('@theme/volume-pricing-info')],
  ['price-per-item', () => import('@theme/price-per-item')],
  ['show-more-component', () => import('@theme/show-more')],
  ['rte-formatter', () => import('@theme/rte-formatter')],
  ['deferred-media', () => import('@theme/media')],
  ['product-price', () => import('@theme/product-price')],
  ['product-model', () => import('@theme/media')],
]);
const pending = new Set();

function loadWithin(root) {
  if (!(root instanceof Element) && root !== document) return;
  for (const [selector, load] of components) {
    if (customElements.get(selector)) {
      components.delete(selector);
      continue;
    }
    if (pending.has(selector) || !(root.matches?.(selector) || root.querySelector(selector))) continue;
    pending.add(selector);
    load().then(() => {
      components.delete(selector);
      if (!components.size) observer.disconnect();
    }).catch((error) => {
      // Permit another attempt on a later insertion rather than permanently disabling the component.
      console.error(`Unable to load ${selector}`, error);
    }).finally(() => pending.delete(selector));
  }
  if (!components.size) observer.disconnect();
}

const observer = new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) loadWithin(node);
  }
});
observer.observe(document.documentElement, { childList: true, subtree: true });
loadWithin(document);
